import { useQuery } from '@tanstack/react-query';
import { mailMonitorKeys } from '../../queryKeys';
import { myUnreadApi } from './myUnreadApi';

/**
 * The signed-in employee's unread mail, for the header badge, the dashboard card and the desktop pop-up (one
 * query, so they always agree). The server checks the mailboxes every minute, so a 60-second refresh is enough;
 * it keeps running in a background tab so the pop-up still arrives. No retries on 401/403.
 */
export const useMyUnreadMail = (companyId: number | null) =>
  useQuery({
    queryKey: mailMonitorKeys.mine(companyId ?? 0),
    queryFn: () => myUnreadApi.mine(companyId as number),
    enabled: Boolean(companyId),
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
    retry: (count, error) => {
      const status = (error as { status?: number })?.status;
      return count < 2 && status !== 401 && status !== 403;
    },
  });
